import { CopyToClipboard } from '@10xLabs/react-web/components/CopyToClipboard'
import { ReactElement, useState } from 'react'
import { TableContainer, Table, Thead, Th, Tbody, Tr, TdId, IdWrapper, Td } from 'components/v2/Table'
import { FormattedMessage } from 'react-intl'

import { IsActive, IsAssigned } from 'components/Chip'
import { FEATURES } from 'features/Roles/components/Permissions/constants'
import { canWrite } from 'features/Users/utils'
import { useLogin } from 'features/Login/hooks'
import { DriversListActions } from 'features/Drivers/components/DriversList/Actions'
import { SuccessResetPasswordRequestModal } from 'features/UserAccount/components/SuccessResetPasswordRequestModal'
import { GTTDriver } from 'gql/types.generated'

interface IDriversListProps {
  drivers: GTTDriver[]
}

const DriversList = ({ drivers }: IDriversListProps): ReactElement => {
  const login = useLogin()
  const { policies } = login.accessToken
  const canSeeActions = canWrite(FEATURES.DRIVER, policies)
  const [userAccountForPasswordReset, setUserAccountForPasswordReset] = useState<GTTDriver['userAccount'] | null>(null)

  return (
    <div>
      <TableContainer overflow>
        <Table>
          <Thead>
            <Tr>
              {canSeeActions && <Th noUppercase></Th>}
              <Th>
                <FormattedMessage id="drivers.id" defaultMessage="Driver ID" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.userAccountId" defaultMessage="User Account ID" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.status" defaultMessage="Status" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.assignedStatus" defaultMessage="Assigned Status" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.name" defaultMessage="Name" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.partner" defaultMessage="Partner" />
              </Th>
              <Th>
                <FormattedMessage id="drivers.vehicles" defaultMessage="Vehicles" />
              </Th>
            </Tr>
          </Thead>
          <Tbody>
            {drivers.map((driver) => {
              return (
                <Tr key={driver.id}>
                  {canSeeActions && (
                    <Td>
                      <DriversListActions driver={driver} setResetPasswordModal={setUserAccountForPasswordReset} />
                    </Td>
                  )}
                  <TdId>
                    <IdWrapper>
                      {driver.id.substring(0, 8)}
                      <CopyToClipboard str={driver.id} />
                    </IdWrapper>
                  </TdId>
                  <TdId>
                    <IdWrapper>
                      {driver.userAccount.id.substring(0, 8)}
                      <CopyToClipboard str={driver.userAccount.id} />
                    </IdWrapper>
                  </TdId>
                  <Td>
                    <IsActive isActive={driver.isEnabled} />
                  </Td>
                  <Td>
                    <IsAssigned isAssigned={driver.isAssigned} />
                  </Td>
                  <Td>{`${driver.userAccount.firstName ?? ''} ${driver.userAccount.lastName ?? ''}`}</Td>
                  <Td>{driver.partner.name}</Td>
                  <Td>{driver.vehicles.length}</Td>
                </Tr>
              )
            })}
          </Tbody>
        </Table>
      </TableContainer>
      {userAccountForPasswordReset && (
        <SuccessResetPasswordRequestModal
          userAccountEmail={userAccountForPasswordReset.email as string}
          onClose={(): void => setUserAccountForPasswordReset(null)}
        />
      )}
    </div>
  )
}

export default DriversList
